import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import SectionTitle from '../../Layout/components/SectionTitle';
import {withLocalize} from 'react-localize-redux';
import translations from '../translations/translations_errors';
import ReactHtmlParser from 'react-html-parser';

class ErrorNotFound extends Component {
    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    render() {
        const title = ReactHtmlParser(this.props.translate('errors_404.title', null, {renderInnerHtml: false}));

        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'page page-error vertical-content-force-height-100'
                    }}
                />
                <div className="container">
                    <SectionTitle cssClass="mt-0 mb-0 align-items-center" title={<Fragment>{title}</Fragment>} subtitle={this.props.translate('errors_404.description')} />
                </div>
            </Fragment>
        );
    }
}

ErrorNotFound.propTypes = {
    translate: PropTypes.func.isRequired
};

export default withLocalize(ErrorNotFound);


// WEBPACK FOOTER //
// ./src/features/Errors/components/ErrorNotFound.js